<template>
  <themed-modal
    :name="`subscription-preview-${_uid}`"
    title="Preview Changes"
    subtitle="Review your subscription changes before confirming"
    size="lg"
    :show-footer="true"
    @closed="handleClose"
  >
    <!-- Summary Section -->
    <div class="subscription-preview-summary">
      <div class="summary-grid">
        <div>
          <p class="summary-label">Plan</p>
          <p class="summary-value">{{ selection?.plan?.name || 'No plan selected' }}</p>
        </div>
        <div>
          <p class="summary-label">Billing Cycle</p>
          <p class="summary-value">{{ billingCycle }}</p>
        </div>
      </div>
    </div>

    <!-- Line Items Table -->
    <div class="subscription-preview-items">
      <h3 class="items-title">Order Summary</h3>
      
      <themed-table
        :data="previewData.lines"
        :columns="lineColumns"
        compact
      >
        <template #column-description="{ row }">
          <div>
            {{ row.description }}
            <div v-if="row.proration" class="proration-note">
              Prorated amount
            </div>
          </div>
        </template>

        <template #column-amount="{ row }">
          <span :class="{ 'amount-negative': row.amount < 0 }">
            {{ formatCurrencyCents(row.amount) }}
          </span>
        </template>
      </themed-table>

      <div class="subscription-preview-total">
        <span>Total amount due:</span>
        <span class="total-amount">{{ formatCurrencyCents(previewData.amount_due) }}</span>
      </div>
    </div>

    <template #footer>
      <div class="subscription-preview-actions">
        <themed-button
          variant="outline"
          @click="handleClose"
          :disabled="isCommitting"
        >
          Cancel
        </themed-button>
        <themed-button
          @click="$emit('confirm')"
          :disabled="isCommitting"
        >
          {{ isCommitting ? 'Processing...' : 'Confirm Changes' }}
        </themed-button>
      </div>
    </template>
  </themed-modal>
</template>

<script>
import { formatCurrencyCents } from '../../../../utils/formatters';
import ThemedModal from '../ThemedModal.vue';
import ThemedTable from '../ThemedTable.vue';
import ThemedButton from '../ThemedButton.vue';

export default {
  name: 'SubscriptionPreview',
  components: {
    ThemedModal,
    ThemedTable,
    ThemedButton
  },
  props: {
    value: Boolean,
    previewData: {
      type: Object,
      default: () => ({
        period_end: null,
        items: [],
        amount_due: 0,
        current_subscription: {},
        new_subscription: {},
        selection: {},
        lines: []
      })
    },
    isCommitting: {
      type: Boolean,
      default: false
    },
    currentPlan: {
      type: Object,
      default: () => ({})
    },
    newPlan: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      lineColumns: [
        { field: 'description', label: 'Description' },
        { field: 'amount', label: 'Amount', type: 'currency' }
      ]
    };
  },
  computed: {
    selection() {
      return this.previewData.selection;
    },
    billingCycle() {
      return this.newPlan?.interval || 'month';
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$modal.show(`subscription-preview-${this._uid}`);
        } else {
          this.$modal.hide(`subscription-preview-${this._uid}`);
        }
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('input', false);
      this.$emit('close');
    },
    formatCurrencyCents(cents, currency = 'USD') {
      return formatCurrencyCents(cents, currency);
    }
  }
};
</script>
